import React from 'react';
import './App.css';
import EditProductItem from './EditProductItem.js';
import EditableLabelItem from './EditableLabelItem.js';
import Button from 'react-bootstrap/Button'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import { MdSignalWifi4Bar, MdSignalWifi0Bar, MdUnfoldLess, MdUnfoldMore, MdVignette, MdFileUpload, MdFiberNew, MdSlideshow, MdShare, MdLibraryAdd, MdDelete, MdDeleteForever, MdCheck, MdCheckBoxOutlineBlank, MdContentCopy, MdImage, MdBrokenImage, MdArchive, MdDesktopMac, MdPhoneIphone } from 'react-icons/md'
import { DiJava } from 'react-icons/di'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'


class MenuItem extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            deleteProduct: false,
            addProduct: false,
            prevScrollpos: window.pageYOffset,
            menuVisible: true,
        }
    }

    handleProductRemoved(stylecode) {
        this.setState({
            deleteProduct: false
        });
        this.props.onProductDeleted(stylecode);
    }

    handleProductAdded(stylecode) {
        this.setState({
            addProduct: false
        });
        this.props.onProductAdded(stylecode);

    }

    handleDeleteClick() {
        this.setState({
            deleteProduct: true
        });
    }

    handleAddClick() {
        this.setState({
            addProduct: true
        });
    }

    handleShare() {
        this.props.onShare();
    }

    handleEnableEditClick() {
        this.props.onEditClick();
    }

    handleSelectAllClick() { this.props.onSelectClick('All'); }
    handleSelectNoneClick() { this.props.onSelectClick('None'); }

    getOverlay(overlayText) {
        return (
            <Tooltip>
                {overlayText}
            </Tooltip>
        );
    }

    // menu hide / show handling
    componentDidMount() {
        window.addEventListener("scroll", this.handleScroll);
    }
    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
    }

    // Hide or show the menu.
    handleScroll = () => {
        //        console.log('scroll')
        const { prevScrollpos } = this.state;
        const currentScrollPos = window.pageYOffset;
        const visible = prevScrollpos > currentScrollPos;

        this.setState({
            prevScrollpos: currentScrollPos,
            menuVisible: visible,
        });
    };

    render() {
        var colStyle = " menuBar";
        return (
            <div className="menuHeaderContainer" style={{ height: (this.state.menuVisible ? "105px" : "35px") }}>
                <div className="row">
                    <EditableLabelItem isEnabled={this.props.isEnabled} onTitleChanged={(txt) => { this.props.onTitleChanged(txt) }} title={this.props.title + ' ' + process.env.REACT_APP_VMT_ENV} />
                    {this.state.menuVisible ? <MdUnfoldLess /> : <MdUnfoldMore />}
                </div>
                <div className="row" style={{ display: (this.props.isEnabled ? 'none' : '') }}>
                    <div className={colStyle}>
                        <ButtonGroup>
                            <Button variant="outline-light" onClick={() => this.handleEnableEditClick()}>
                                Current content is readonly. Click to edit but the current share, if any, will not be affected.
                                </Button>
                        </ButtonGroup>
                    </div>
                </div>
                <div className={"row navbar " + (!this.state.menuVisible ? "navbarHidden" : "")} style={{ display: (!this.props.isEnabled ? 'none' : '') }}>
                    <div className={colStyle}>
                        <ButtonGroup >
                            <OverlayTrigger placement='bottom' overlay={this.getOverlay('New empty template')}>
                                <Button variant="outline-light" onClick={() => this.props.onTemplateClick()} >
                                    <MdFiberNew />
                                </Button>
                            </OverlayTrigger>
                            <OverlayTrigger placement='bottom' overlay={this.getOverlay('Upload a file')}>
                                <Button variant="outline-light">
                                    <label htmlFor="fUpload"><MdFileUpload />
                                        <input className="btn btn-outline-light" id="fUpload" style={{ display: 'none' }} type="file" onChange={(e) => this.props.onHandleselectedFile(e)} />
                                    </label>
                                </Button>
                            </OverlayTrigger>
                            <OverlayTrigger placement='bottom' overlay={this.getOverlay('Download excel file with all the informations')}>
                                <Button variant="outline-light" onClick={() => this.props.onFullDownloadClick()}
                                    style={{ display: (!this.props.fileGenerated ? '' : 'none') }} >
                                    <MdArchive />
                                </Button>
                            </OverlayTrigger>

                            <OverlayTrigger placement='bottom' overlay={this.getOverlay('Download excel file to be imported into hybris')}>
                                <Button variant="outline-light" onClick={() => this.props.onDownloadForHybrisClick()}
                                    style={{ display: (!this.props.fileGeneratedForHybris ? '' : 'none') }} >
                                    <DiJava />
                                </Button>
                            </OverlayTrigger>

                            <OverlayTrigger placement='bottom' overlay={this.getOverlay('Desktop or mobile View')}>
                                <Button variant="outline-light" onClick={() => this.props.onSwitchViewClick()}>
                                    {this.props.viewMobile ? <MdPhoneIphone /> : <MdDesktopMac />}
                                </Button>
                            </OverlayTrigger>

                            <OverlayTrigger placement='bottom' overlay={this.getOverlay('Filter visible products based on missing image')}>
                                <Button variant="outline-light" onClick={() => this.props.onMissingImagesViewClick()}>
                                    {this.props.missingImages ? <MdBrokenImage /> : <MdImage />}
                                </Button>
                            </OverlayTrigger>

                            <OverlayTrigger placement='bottom' overlay={this.getOverlay('Copy selected products')}>
                                <Button variant="outline-light" onClick={() => this.props.onCopyClick()}>
                                    <MdContentCopy />
                                </Button>
                            </OverlayTrigger>

                            <OverlayTrigger placement='bottom' overlay={this.getOverlay('Select All')}>
                                <Button variant="outline-light" onClick={() => this.handleSelectAllClick()}>
                                    <MdCheck />
                                </Button>
                            </OverlayTrigger>

                            <OverlayTrigger placement='bottom' overlay={this.getOverlay('Select None')}>
                                <Button variant="outline-light" onClick={() => this.handleSelectNoneClick()}>
                                    <MdCheckBoxOutlineBlank />
                                </Button>
                            </OverlayTrigger>

                            <OverlayTrigger placement='bottom' overlay={this.getOverlay('Delete list of products')}>
                                <Button variant="outline-light" onClick={() => this.handleDeleteClick()}>
                                    <MdDelete />
                                </Button>
                            </OverlayTrigger>

                            <OverlayTrigger placement='bottom' overlay={this.getOverlay('Delete selcted products')}>
                                <Button variant="outline-light" onClick={() => this.props.onDeleteSelectedClick()}>
                                    <MdDeleteForever />
                                </Button>
                            </OverlayTrigger>

                            <OverlayTrigger placement='bottom' overlay={this.getOverlay('Add products')}>
                                <Button variant="outline-light" onClick={() => this.handleAddClick()}>
                                    <MdLibraryAdd />
                                </Button>
                            </OverlayTrigger>

                            <OverlayTrigger placement='bottom' overlay={this.getOverlay('Share')}>
                                <Button variant="outline-light" onClick={() => this.handleShare()}>
                                    <MdShare />
                                </Button>
                            </OverlayTrigger>

                            <OverlayTrigger placement='bottom' overlay={this.getOverlay('Hero image')}>
                                <Button variant="outline-light" onClick={() => this.props.onPromoSearch()}>
                                    <MdVignette />
                                </Button>
                            </OverlayTrigger>

                            <OverlayTrigger placement='bottom' overlay={this.getOverlay('Preview')}>
                                <Button variant="outline-light" onClick={() => this.props.onPreview()}>
                                    {this.props.isEnabled ? <MdSlideshow /> : ''}
                                </Button>
                            </OverlayTrigger>

                            <OverlayTrigger placement='bottom' overlay={this.getOverlay((this.props.isProd ? 'PROD ' : 'DEV ') + ' ImageServer')}>
                                <Button variant="outline-light" onClick={() => this.props.onSwitchIs()}>
                                    {this.props.isProd ? <MdSignalWifi4Bar /> : <MdSignalWifi0Bar />}
                                </Button>
                            </OverlayTrigger>

                        </ButtonGroup>

                        <EditProductItem action='Add' shouldShow={this.state.addProduct}
                            onClose={() => this.setState({ addProduct: false })}
                            onProductAdded={(stylecode => this.handleProductAdded(stylecode))} />

                        <EditProductItem action='Remove' shouldShow={this.state.deleteProduct}
                            onClose={() => this.setState({ deleteProduct: false })}
                            onProductRemoved={(stylecode => this.handleProductRemoved(stylecode))} />

                    </div>
                </div>
            </div>
        );
    }

}

export default MenuItem;